import type { TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, EventEmitter, Output, ContentChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { Widgets } from '@common/enums';

@Component({
    selector: 'sp-toolbar-widget',
    templateUrl: './widget.component.html',
    styleUrls: ['./widget.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TooltipModule],
})
export class ToolbarWidgetComponent {
    @ContentChild('labelTemplate') public labelTemplate!: TemplateRef<any> | null;

    @Input() name!: Widgets;
    @Input() title!: string;
    @Input() disabled: boolean = false;
    @Input() disabledTooltip: string = '';

    @Output() onClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

    public widgets = Widgets;
}
